import toolList from "./toolList.js";

const url = import.meta.env.VITE_APP_API_TRADE

export default {

    actions: {
        async fetchTrades({commit, getters}, ) {
            commit('SET_TRADE_LIST_LOADING_STATUS', 'loading')
            const  resJson = await fetch(`${url}/order/history-list/${getters.getActiveTool.direction}?limit=50`) //`${url}/order/dials/${getters.getActiveTool.direction}`
            const res = await resJson.json()
            if(res.code === 200) {
                commit('SET_TRADE_LIST', res.data.items)
                commit('SET_TRADE_LIST_LOADING_STATUS', 'success')
            } else {
                commit('SET_TRADE_LIST_LOADING_STATUS', 'error')
            }
        },
    },

    mutations: {
        SET_TRADE_LIST(state, orders) {
            state.tradeList = orders
        },
        SET_TRADE_LIST_LOADING_STATUS(state, status) {
            state.tradeListLoadingStatus = status
        },
        SOCKET_ONMESSAGE(state, message) {
            const activeTool = this.getters.getActiveTool
            if(message.t == 'dl' && activeTool != null && activeTool.direction == message.d) {

                state.tradeList.unshift({
                    "price" : message.p,
                    "volume": message.v,
                    "side": message.ag == 's'? 'sell' : 'buy',
                    "date_time": Math.floor(Date.now() / 1000)
                })
                if(state.tradeList.length > 50) {
                    state.tradeList.pop()
                }
            }
        },
    },
    state: {
        tradeListLoadingStatus: 'loading',
        tradeList: [],
    },
    getters: {
        getTradeList:(state) => state.tradeList,
        getTradeListLoadingStatus:(state) => state.tradeListLoadingStatus,
    },
}